module.exports = require('./dist/ReactCrop');
